import React from "react";
import { motion } from "framer-motion";
import { EXPERIENCE } from "../../data/content";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export default function ProExperience() {
  return (
    <div className="pt-24 pb-16" data-testid="pro-experience">
      <section className="max-w-6xl mx-auto px-5 md:px-8">
        <p className="font-plexMono text-xs uppercase tracking-[0.2em] text-terracotta">
          Experience
        </p>
        <h1 className="font-serif font-light text-4xl md:text-6xl text-neutral-900 mt-3">
          Where I&apos;ve been.
        </h1>
        <p className="font-plex text-neutral-600 mt-4 max-w-2xl">
          Three years across two consultancies — implementations, integrations, upgrades and support
          projects on Microsoft Dynamics 365 Business Central.
        </p>

        <div className="mt-16 space-y-14">
          {EXPERIENCE.map((job, i) => (
            <motion.article
              key={job.company}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="grid md:grid-cols-12 gap-6 md:gap-10 border-t border-neutral-200 pt-10"
              data-testid={`pro-exp-${job.company.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="md:col-span-4">
                <p className="font-plexMono text-xs uppercase tracking-widest text-terracotta">
                  {job.period}
                </p>
                <h2 className="font-serif text-3xl md:text-4xl text-neutral-900 mt-2">
                  {job.company}
                </h2>
                <p className="font-plex text-sm text-neutral-500 mt-1">{job.location}</p>
              </div>
              <div className="md:col-span-8">
                <p className="font-plex text-lg font-medium text-neutral-900">{job.role}</p>
                <p className="font-plex text-neutral-600 mt-3 leading-relaxed">{job.blurb}</p>

                {job.highlights && (
                  <ul className="mt-6 space-y-3">
                    {job.highlights.map((h, idx) => (
                      <li key={idx} className="font-plex text-neutral-700 leading-relaxed flex gap-3">
                        <span className="text-terracotta mt-1.5 shrink-0">●</span>
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                )}

                <div className="mt-6 flex flex-wrap gap-2">
                  {job.tags.map((tag) => (
                    <span
                      key={tag}
                      className="font-plexMono text-xs px-3 py-1 border border-neutral-200 rounded-full text-neutral-600"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
